import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AcUnitIcon(props: IconProps) {
    return <Icon {...props} iconKey={"ac_unit"}/>
}
